/**
 * Nudge — a one-time note at a confusing moment. No spotlight; a small card
 * that sits above the nav until dismissed. Pair with useNudge(key, when).
 */

import { Lightbulb, X } from 'lucide-react';

export default function Nudge({ title, text, onDismiss, action, onAction }) {
  return (
    <div className="fixed inset-x-0 bottom-16 sm:bottom-6 z-40 px-3 pointer-events-none" role="status">
      <div className="max-w-md mx-auto rounded-xl border border-amber-700/50 bg-slate-900/95 backdrop-blur shadow-lg p-3.5 pointer-events-auto">
        <div className="flex items-start gap-2.5">
          <Lightbulb size={16} className="text-amber-300 mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-slate-100">{title}</p>
            <p className="text-xs text-slate-400 leading-relaxed mt-0.5">{text}</p>
            {action && (
              <button onClick={() => { onAction?.(); onDismiss(); }} className="mt-2 text-xs text-indigo-300 hover:text-indigo-200">{action}</button>
            )}
          </div>
          <button onClick={onDismiss} aria-label="Got it" className="text-slate-500 hover:text-slate-300 p-1 -m-1"><X size={14} /></button>
        </div>
      </div>
    </div>
  );
}
